import { Component, OnInit, ViewChild } from '@angular/core';
import { ConsultaGeneralUsuarioComponent } from '../consulta-general-usuario/consulta-general-usuario.component';
import { ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable, LoadingPanelService, VisorComponent } from 'lib-base';
import { firstValueFrom, forkJoin } from 'rxjs';
import { FacturaService } from '../../../services/liquidacion/factura.service';
import { IGetMisFacturas, IReimpresionFactura } from '../../../shared/interfaces/liquidacion';
import { TranslateService } from '@ngx-translate/core';
import { ReciboService } from '../../../services/recibo.service';

@Component({
  selector: 'app-mis-facturas',
  standalone: true,
  imports: [ConsultaGeneralUsuarioComponent, CustomTableComponent, VisorComponent],
  templateUrl: './mis-facturas.component.html',
  styleUrl: './mis-facturas.component.scss'
})
export class MisFacturasComponent implements OnInit {

  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(VisorComponent) visorDialog !: VisorComponent;

  constructor(private _fs: FacturaService, private _t: TranslateService, private reciboService: ReciboService,
    private _lps: LoadingPanelService
  ) { }

  ngOnInit(): void {
    this.translate();
    this.getMisFacturas();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      referencia: this._t.get('common.referencia'),
      factura: this._t.get('common.factura'),
      loteFacturacion: this._t.get('common.loteFacturacion'),
      fechaRegistro: this._t.get('common.fechaRegistro'),
      fechaVencimiento: this._t.get('common.fechaVencimiento'),
      impuesto: this._t.get('common.impuesto'),
      concepto: this._t.get('common.concepto'),
      totalPago: this._t.get('common.totalPago'),
      misFacturas: this._t.get('common.misFacturas'),
      nombreTramite: this._t.get('common.nombreTramite'),
    }));
    this.configureTable();
  }

  private configureTable() {
    this.customTable = {
      settings: {
        table: {
          rows: 7,
        }
      },
      columns: [
        {
          field: 'referencia',
          header: this.trans.referencia,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'factura',
          header: this.trans.factura,
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'fechaRegistro',
          header: this.trans.fechaRegistro,
          dataType: DataColumnType.DATE
        },
        {
          field: 'fechaVencimiento',
          header: this.trans.fechaVencimiento,
          dataType: DataColumnType.DATE
        },
        {
          field: 'impuesto',
          header: this.trans.impuesto,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'concepto',
          header: this.trans.concepto,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'nombreTramite',
          header: this.trans.nombreTramite,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'totalPago',
          header: this.trans.totalPago,
          dataType: DataColumnType.MONEY
        },
        {
          field: 'abrir',
          header: '',
          icon: 'pi pi-search',
          class: 'button-edit p-button-outlined pt-2 pb-2',
          width: '0rem',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: IGetMisFacturas) => this.openDetalleRecibo(data),
        }
      ]
    } as ICustomTable;
  }


  //#region API Calls
  private getMisFacturas() {
    this._fs.getMisFacturas().subscribe({
      next: (res: IGetMisFacturas[]) => {
        this.customTableComponent.data = res;
      },
    });
  }


  openDetalleRecibo(data: IGetMisFacturas) {
    let request = {
      loteFacturacion: data.loteFacturacion,
      factura: data.factura
    } as IReimpresionFactura;

    this._lps.show();
    this.reciboService.reimpresionFactura(request).subscribe({
      next: value => {
        this._lps.hide();
        this.visorDialog.showDialog(value);
      }
    })
  }
  //#endregion API Calls

}
